import type {Mapper} from 'framework';
import type {WeightEntry} from '../../domain/weight-entry';
import type {WeightEntryDto} from '../dto/weight-entry.dto';

const toDate = (value: string | Date): Date =>
  value instanceof Date ? value : new Date(value);

export class WeightEntryDtoToWeightEntryMapper implements Mapper<WeightEntryDto, WeightEntry> {
  transform(dto: WeightEntryDto): WeightEntry {
    return {
      id: dto.id,
      weightKg: dto.weightKg,
      recordedAt: toDate(dto.recordedAt),
      createdAt: toDate(dto.createdAt),
    };
  }
}
